/**
 * Ingredients System - Moon Moon Agency v2.1
 * Tabs panel switching and load more (accordion handled by DropdownManager)
 */

/*********************************************************************************************
 * ⚙️ CONFIGURATION & CONSTANTS
 */
const INGREDIENTS_CONFIG = {
	selectors: {
		section: '.mm-ingredients',
		tab: '.mm-ingredients__tab',
		panelKey: '.mm-ingredients__panel--key',
		panelAll: '.mm-ingredients__panel--all',
		item: '.mm-ingredients__item',
		loadMore: '.mm-ingredients__load-more'
	}
};

/*********************************************************************************************
 * 🏗️ GLOBAL FUNCTIONS
 */

// Tab switching — toggles between key ingredients list and full composition text
function initTabs(section) {
	const tabs = section.querySelectorAll(INGREDIENTS_CONFIG.selectors.tab);
	const panelKey = section.querySelector(INGREDIENTS_CONFIG.selectors.panelKey);
	const panelAll = section.querySelector(INGREDIENTS_CONFIG.selectors.panelAll);

	if (!panelKey || !panelAll) return;

	tabs.forEach(tab => {
		tab.addEventListener('click', () => {
			// Update tab styles
			tabs.forEach(t => {
				t.classList.remove('mm-ingredients__tab--active', 'mm-btn-secondary');
				t.classList.add('mm-btn-primary');
				t.setAttribute('aria-selected', 'false');
			});
			tab.classList.add('mm-ingredients__tab--active', 'mm-btn-secondary');
			tab.classList.remove('mm-btn-primary');
			tab.setAttribute('aria-selected', 'true');

			// Switch panels
			const isKey = tab.dataset.tab === 'key';
			panelKey.classList.toggle('mm-none', !isKey);
			panelKey.setAttribute('aria-hidden', String(!isKey));
			panelAll.classList.toggle('mm-none', isKey);
			panelAll.setAttribute('aria-hidden', String(isKey));
		});
	});
}

// Load more — reveals hidden items
function initLoadMore(section) {
	const loadMoreBtn = section.querySelector(INGREDIENTS_CONFIG.selectors.loadMore);
	if (!loadMoreBtn) return;

	loadMoreBtn.addEventListener('click', () => {
		const items = section.querySelectorAll(INGREDIENTS_CONFIG.selectors.item);
		items.forEach(item => {
			item.style.display = '';
			item.removeAttribute('aria-hidden');
		});
		loadMoreBtn.style.display = 'none';
	});
}

/*********************************************************************************************
 * 🚀 INITIALIZATION
 */
document.addEventListener('DOMContentLoaded', () => {
	const sections = document.querySelectorAll(INGREDIENTS_CONFIG.selectors.section);

	sections.forEach(section => {
		initTabs(section);
		initLoadMore(section);
	});
});
